import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { ComboBoxModule, DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { ExcelModule, GridModule, PDFModule } from '@progress/kendo-angular-grid';
import { NumericTextBoxModule } from '@progress/kendo-angular-inputs';
import { IntlModule } from "@progress/kendo-angular-intl";
import { MessageService } from '@progress/kendo-angular-l10n';
import { PopupModule } from '@progress/kendo-angular-popup';
import { KendoTranslateService } from './kendo-translate.service';



@NgModule({
  imports: [
    CommonModule,
    GridModule,
    DropDownsModule,
    ComboBoxModule,
    DateInputsModule,
    NumericTextBoxModule,
    PopupModule,
    IntlModule,
    PDFModule,
    ExcelModule
  ],
  exports: [
    GridModule,
    DropDownsModule,
    ComboBoxModule,
    DateInputsModule,
    NumericTextBoxModule,
    PopupModule,
    IntlModule,
    PDFModule,
    ExcelModule
  ],
  providers: [
    { provide: MessageService, useClass: KendoTranslateService }
  ]
})
export class KendoModule { }
